import React from 'react';
import { ImageUploader } from '../index';

function ContentImageUploader() {
    return(
        <ImageUploader aspectRatio={16/6}/>
    )
};

export { ContentImageUploader };